import { Link } from 'react-router-dom'; export function NotFound(){return <div className="center-screen"><div><h1>We couldn’t find that page.</h1><Link className="btn primary" to="/">Back to MyLearningWorld</Link></div></div>}
